import { fetchInvestmentOptionDataType, fetchUnderlyingTableDataType, processedDataType } from './actionTypes'

export const fetchInvestmentOptionData = payload => ({
  type: fetchInvestmentOptionDataType,
  payload
});

export const fetchUnderlyingTableData = payload => ({
  type: fetchUnderlyingTableDataType,
  payload
});

export const processedDataFetch = payload => ({
  type: processedDataType,
  payload
});

